import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import Main from './components/Main';
import Start from './Start';
import './css/Index.css';


if(localStorage.getItem('vas_token'))
{
    ReactDOM.render((<BrowserRouter>
        <Main />
        </BrowserRouter>
    ), document.getElementById('root'));
}
else
{
    ReactDOM.render(( <BrowserRouter><Start /></BrowserRouter>
    ), document.getElementById('root'));
}